import {
  IThailandProvince,
  ThailandRegionEnum,
} from 'interfaces/provice.interface';
import useSWRImmutable from 'swr/immutable';

export default function useProvince() {
  const { data: provinces } = useSWRImmutable<IThailandProvince[]>({
    url: `${process.env.NEXT_PUBLIC_API_URL}/v1/public/provinces`,
    method: 'GET',
  });

  const region = Object.values(ThailandRegionEnum).map((region) => {
    let regionNameTh = '';

    switch (region) {
      case ThailandRegionEnum.BANGKOK_METROPOLIS:
        regionNameTh = 'กรุงเทพฯและปริมณฑล';
        break;
      case ThailandRegionEnum.NORTHERN:
        regionNameTh = 'ภาคเหนือ';
        break;
      case ThailandRegionEnum.NORTHEASTERN:
        regionNameTh = 'ภาคตะวันออกเฉียงเหนือ';
        break;
      case ThailandRegionEnum.CENTRAL:
        regionNameTh = 'ภาคกลาง';
        break;
      case ThailandRegionEnum.SOUTHERN:
        regionNameTh = 'ภาคใต้';
        break;
      case ThailandRegionEnum.WESTERN:
        regionNameTh = 'ภาคตะวันตก';
        break;
      case ThailandRegionEnum.EASTERN:
        regionNameTh = 'ภาคตะวันออก';
        break;
      default:
        regionNameTh = 'NA';
        break;
    }

    return {
      name: regionNameTh,
      value: region,
    };
  });

  return {
    provinces: provinces,
    region: region,
  };
}
